import React, {
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";

const CloudflareTurnstile = forwardRef(
  ({ siteKey, onSuccess, onError }, ref) => {
    const widgetRef = useRef(null);
    const widgetIdRef = useRef(null);
    const mountedRef = useRef(false);

    useImperativeHandle(ref, () => ({
      execute: () => {
        if (widgetIdRef.current && window.turnstile) {
          window.turnstile.execute(widgetIdRef.current);
        }
      },
      reset: () => {
        if (widgetIdRef.current && window.turnstile) {
          window.turnstile.reset(widgetIdRef.current);
        }
      },
    }));

    useEffect(() => {
      if (mountedRef.current || !window.turnstile || !widgetRef.current) return;

      widgetIdRef.current = window.turnstile.render(widgetRef.current, {
        sitekey: siteKey,
        callback: onSuccess,
        "error-callback": (errorCode) => {
          console.error("🚨 Turnstile error:", errorCode);
          if (onError) onError(errorCode);
          if (widgetIdRef.current && window.turnstile) {
            window.turnstile.reset(widgetIdRef.current); // ✅ redémarre le challenge
          }
        },
      });

      mountedRef.current = true;
    }, [siteKey, onSuccess, onError]);

    return <div ref={widgetRef} />;
  }
);

export default CloudflareTurnstile;
